import { render } from "./runLuckDraw.vue?vue&type=template&id=96ddaf1a&scoped=true"
import script from "./runLuckDraw.vue?vue&type=script&lang=js"
export * from "./runLuckDraw.vue?vue&type=script&lang=js"

import "./runLuckDraw.vue?vue&type=style&index=0&id=96ddaf1a&scoped=true&lang=css"

import exportComponent from "E:\\waibao\\isa-community-toupin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ddaf1a"]])

export default __exports__